<div class="password-container">
  <rt-dialog-header [heading]="translationKey.adminPasswordForm.changePassword | translate" />
  <rt-dialog-body>
    <form [formGroup]="accountPasswordForm" class="profile-form">
      @if (requireCurrentPassword()) {
        <rt-form-field margin-bottom-small [hideRequiredBadge]="true">
          <rt-label>
            {{ translationKey.adminPasswordForm.currentPassword | translate }}
          </rt-label>
          <rt-input
            variant="rounded"
            [placeholder]="translationKey.adminPasswordForm.currentPasswordPlaceholder | translate"
            [autoFocus]="requireCurrentPassword()"
            type="password"
            formControlName="currentPassword"
          />
          @if (
            accountPasswordForm.get('currentPassword')?.errors?.backend &&
            accountPasswordForm.get('currentPassword')?.touched
          ) {
            <span class="error">
              {{ translationKey.authenticationForm.invalidPassword | translate }}
            </span>
          }
        </rt-form-field>
      }

      <rt-form-field margin-bottom-small [hideRequiredBadge]="true">
        <rt-label>
          {{ translationKey.adminPasswordForm.newPassword | translate }}
        </rt-label>
        <rt-input
          variant="rounded"
          [placeholder]="translationKey.adminPasswordForm.yourPassword | translate"
          [autoFocus]="!requireCurrentPassword()"
          type="password"
          formControlName="password"
        />
      </rt-form-field>
      <div layout-vertical margin-bottom padding-left-small-x>
        <div
          [class.inactive]="
            !getPasswordErrors().minlength &&
            !getPasswordErrors().maxlength &&
            !getPasswordErrors().required
          "
          class="validation-row"
          layout-horizontal
          layout-centered-y
        >
          <rt-icon size="small-xx" name="fa-caret-right" />
          {{ translationKey.adminPasswordForm.passwordLength | translate: { min: 8, max: 72 } }}
        </div>
        <div
          [class.inactive]="!getPasswordErrors().upperLowerCase"
          class="validation-row"
          layout-horizontal
          layout-centered-y
        >
          <rt-icon size="small-xx" name="fa-caret-right" />
          {{ translationKey.adminPasswordForm.useLowerUpper | translate }}
        </div>
        <div
          [class.inactive]="!getPasswordErrors().required && !getPasswordErrors().pattern"
          class="validation-row"
          layout-horizontal
          layout-centered-y
        >
          <rt-icon size="small-xx" name="fa-caret-right" />
          {{ translationKey.adminPasswordForm.oneNumber | translate }}
        </div>
      </div>
      <rt-form-field [hideRequiredBadge]="true">
        <rt-label>
          {{ translationKey.adminPasswordForm.confirmNewPassword | translate }}
        </rt-label>
        <rt-input
          variant="rounded"
          [placeholder]="translationKey.adminPasswordForm.confirmNewPassword | translate"
          [rtFormError]="errors"
          (focus)="focus()"
          (focusout)="focusOut()"
          type="password"
          formControlName="passwordConfirmation"
        />
        @if (
          accountPasswordForm.errors && accountPasswordForm.errors.mismatchedPasswords && !focused
        ) {
          <span class="error">
            {{ errors.mismatchedPasswords }}
          </span>
        }
      </rt-form-field>
    </form>
  </rt-dialog-body>
  <rt-dialog-footer>
    @if (!isLoading) {
      <rt-button (click)="cancelClick()" variant="plain">
        {{ translationKey.common.cancel | translate }}
      </rt-button>
    }
    <rt-button
      [loading]="isLoading"
      [disabled]="accountPasswordForm.invalid"
      (click)="submit()"
      variant="primary"
    >
      {{ translationKey.adminPasswordForm.title | translate }}
    </rt-button>
  </rt-dialog-footer>
</div>
